
import { ShopifyCollectionResponse } from './shopify-interfaces';
export default class ShopifyCollection {
  private readonly apiRoot = 'https://u3om7cmtr2.execute-api.us-west-2.amazonaws.com/default/search-products-labwear';

  async get(collectionId: string | number) {
    let response: undefined | ShopifyCollectionResponse;
    try {
      response = await fetch(`${this.apiRoot}?collection_id=${collectionId}`).then(r => r.json())
    } catch(e) {
      console.error(e);
    }
    return response;
  }
}